export const PartsListResultsColumnsModel = [
  {
    label: 'Status',
    type: 'string',
    property: 'isActive',
    isVisible: true,
    width: 35
  },
  {
    label: 'Part Number',
    type: 'string',
    property: 'number',
    isVisible: true,
    width: 35
  },
  {
    label: 'Part Name',
    type: 'string',
    property: 'name',
    isVisible: true,
    width: 35
  },
  {
    label: 'keyword',
    type: 'string',
    property: 'keywords',
    isVisible: true,
    width: 35
  },
  {
    label: 'Description',
    property: 'description',
    type: 'string',
    isVisible: true,
    width: 35
  },
  {
    label: 'Part Type',
    property: 'partType',
    type: 'string',
    isVisible: true,
    width: 35
  },
  {
    label: 'Product Line',
    property: 'productLine',
    type: 'string',
    isVisible: true,
    width: 35
  },
  {
    label: 'Sub Product Line',
    property: 'subProductLine',
    type: 'string',
    isVisible: true,
    width: 35
  },
  {
    label: 'CAPS Min',
    property: 'materialCostMinimum',
    type: 'string',
    cellClass: 'number',
    isVisible: true,
    width: 35
  },
  {
    label: 'CAPS Max',
    property: 'materialCostMaximum',
    type: 'string',
    cellClass: 'number',
    isVisible: true,
    width: 35
  },
  {
    label: 'SKU',
    template: {
      type: 'content',
      property: 'skuAsHtml'
    },
    type: 'html',
    isVisible: true,
    width: 35
  },
  {
    label: 'Action',
    property: 'isActionProduct',
    type: 'string',
    isVisible: true,
    width: 35
  },
  {
    label: 'Manufacturer',
    property: 'make',
    type: 'string',
    isVisible: true,
    width: 35
  },
  {
    label: 'Legacy ID',
    property: 'legacyId',
    type: 'string',
    isVisible: true,
    width: 35
  }
];

export const PartsListResultsColumnsModelNoCaps = [
  {
    label: 'Status',
    type: 'string',
    property: 'isActive',
    isVisible: true,
    width: 35
  },
  {
    label: 'Part Number',
    type: 'string',
    property: 'number',
    isVisible: true,
    width: 35
  },
  {
    label: 'Part Name',
    type: 'string',
    property: 'name',
    isVisible: true,
    width: 35
  },
  {
    label: 'keyword',
    type: 'string',
    property: 'keywords',
    isVisible: true,
    width: 35
  },
  {
    label: 'Description',
    property: 'description',
    type: 'string',
    isVisible: true,
    width: 35
  },
  {
    label: 'Part Type',
    property: 'partType',
    type: 'string',
    isVisible: true,
    width: 35
  },
  {
    label: 'Product Line',
    property: 'productLine',
    type: 'string',
    isVisible: true,
    width: 35
  },
  {
    label: 'Sub Product Line',
    property: 'subProductLine',
    type: 'string',
    isVisible: true,
    width: 35
  },
  {
    label: 'SKU',
    template: {
      type: 'content',
      property: 'skuAsHtml'
    },
    type: 'html',
    isVisible: true,
    width: 35
  },
  {
    label: 'Action',
    property: 'isActionProduct',
    type: 'string',
    isVisible: true,
    width: 35
  },
  {
    label: 'Manufacturer',
    property: 'make',
    type: 'string',
    isVisible: true,
    width: 35
  },
  {
    label: 'Legacy ID',
    property: 'legacyId',
    type: 'string',
    isVisible: true,
    width: 35
  }
];
